import Fire from "./Fire";
import {
  COLL_MSG_USER,
  COLL_MSG_UNREAD_LOG,
  ADMIN
} from "../util/CommonConstants";
import { TOKEN_KEY } from "../util/Auth";
import UsersColl from "./UsersColl";
import UtilDate from "../util/UtilDate";
import { createRandomId, createRandomIdShort } from "../util/Util";

var db;

class MessagesUserColl {
  constructor() {
    db = Fire.shared.getDatabase();
  }

  async getFirebaseDatabase() {
    return Fire.shared.getDatabase();
  }

  async createIndividualMessage(item, recipient_id) {
    let db = await this.getFirebaseDatabase();

    if (!db) {
      return false;
    }

    const user = JSON.parse(localStorage.getItem(TOKEN_KEY));
    const userId = user.id;

    const recipent_info = await UsersColl.shared.getUserById(recipient_id);

    const user_list = [
      {
        user_name: user.first_name + " " + user.last_name,
        user_id: userId
      },
      {
        user_name: recipent_info.first_name + " " + recipent_info.last_name,
        user_id: recipient_id
      }
    ];

    let user_ids = [userId, recipient_id];

    let currentMsg = {
      from_user_id: userId,
      message_text: item.message,
      create_date: new Date()
    };

    if (item.info) {
      currentMsg = { ...currentMsg, ...item.info };
    }

    let message = {
      subject: item.subject,
      user_list,
      user_ids,
      messages: [currentMsg]
    };

    let dateId = UtilDate.getDateShortOnlyNumber(new Date());
    let subId = item.subject;
    let subIdList = item.subject.split(/ +/);

    if (subIdList && subIdList.length > 1) {
      subId = subIdList.join("").substring(0, 10);
    }

    message.id =
      userId + "_" + dateId + "_" + subId + "_" + createRandomIdShort();
    message.create_date = new Date();
    message.last_update_date = message.create_date;

    let batch = db.batch();

    let msgObj = Object.assign({}, message);
    delete msgObj.id;

    let msgRef = db.collection(COLL_MSG_USER).doc(message.id);
    batch.set(msgRef, msgObj);

    //this is for unread log for admin
    let idRef = db.collection(COLL_MSG_UNREAD_LOG).doc();
    batch.set(idRef, {
      msg_id: message.id,
      user_id: recipient_id,
      create_date: new Date()
    });

    try {
      let resp = await batch.commit();
      return true;
    } catch ({ message }) {
      console.log(message);
      return false;
    }
  }
}

MessagesUserColl.shared = new MessagesUserColl();

export default MessagesUserColl;
